import { styled } from "@mui/material/styles";

import { Dialog } from "@mui/material";

const PREFIX = "MSPBillingPageView";

export const classes = {
  outerContainer: `${PREFIX}-outerContainer`,
  outlinedHeaderLink: `${PREFIX}-outlinedHeaderLink`,
  headerLinksRowOuterContainer: `${PREFIX}-headerLinksRowOuterContainer`,
  headerLinksRowInnerContainer: `${PREFIX}-headerLinksRowInnerContainer`,
  clickableCardContainer: `${PREFIX}-clickableCardContainer`,
  clickableCard: `${PREFIX}-clickableCard`,
  clickableCardTitle: `${PREFIX}-clickableCardTitle`,
  clickableCardSecondaryText: `${PREFIX}-clickableCardSecondaryText`,
  clickableCardNumber: `${PREFIX}-clickableCardNumber`,
  clickableCardCTAText: `${PREFIX}-clickableCardCTAText`,
  accordionCard: `${PREFIX}-accordionCard`,
  accordionContainer: `${PREFIX}-accordionContainer`,
  accordionTitle: `${PREFIX}-accordionTitle`,
  agreementStepContainer: `${PREFIX}-agreementStepContainer`,
  minimumCommitmentText: `${PREFIX}-minimumCommitmentText`,
  tableColumnHeaderText: `${PREFIX}-tableColumnHeaderText`,
  tablePriceCell: `${PREFIX}-tablePriceCell`,
  tablePerUserText: `${PREFIX}-tablePerUserText`,
  tableRowRoot: `${PREFIX}-tableRowRoot`,
  radioTableCellContainer: `${PREFIX}-radioTableCellContainer`,
  stepTitleText: `${PREFIX}-stepTitleText`,
  stepTableTitleText: `${PREFIX}-stepTableTitleText`,
  stepLargeText: `${PREFIX}-stepLargeText`,
  currentAgreementList: `${PREFIX}-currentAgreementList`,
};

export const dialogClasses = {
  agreementTitleWrap: `${PREFIX}-agreementTitleWrap`,
  agreementIconWrap: `${PREFIX}-agreementIconWrap`,
  dialogHeaderContainer: `${PREFIX}-dialogHeaderContainer`,
  dialogTable: `${PREFIX}-dialogTable`,
  tableRowLabel: `${PREFIX}-tableRowLabel`,
  tableRowText: `${PREFIX}-tableRowText`,
  pricingTableRowLabel: `${PREFIX}-pricingTableRowLabel`,
  pricingTableRowText: `${PREFIX}-pricingTableRowText`,
};

export const Root = styled("div")(({ theme }) => ({
  [`& .${classes.outlinedHeaderLink}`]: {
    fontSize: 12,
    display: "flex",
    borderRadius: 10,
    cursor: "pointer",
    padding: "0px 10px",
    alignItems: "center",
    color: "#3C73EB", // TODO: find a match in our theme def for these
    backgroundColor: "#D9E3F7",
    "&:hover": {
      textDecoration: "none",
    },
    "& svg": {
      fontSize: 16,
      paddingLeft: 5,
    },
  },
  [`& .${classes.headerLinksRowOuterContainer}`]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  [`& .${classes.headerLinksRowInnerContainer}`]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    "& p": {
      fontSize: 12,
      marginBottom: 0,
    },
    "& > *:nth-child(2)": {
      marginLeft: 10,
    },
  },
  [`& .${classes.clickableCardContainer}`]: {
    display: "grid",
    marginTop: theme.shape.padding,
    gridTemplateColumns: "repeat(5, 1fr)",
    gridAutoRows: "1fr",
    gridGap: theme.spacing(2),
  },
  [`& .${classes.clickableCard}`]: {
    height: "100%",
    cursor: "pointer",
    boxShadow: "none",
    padding: theme.shape.padding,
    border: `1px solid ${theme.palette.border.xdrTrialCard}`,
    "&:hover": {
      border: `1px solid ${theme.palette.primary.main}`,
    },
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
  },
  [`& .${classes.clickableCardTitle}`]: {
    fontSize: 13,
    fontWeight: "bold",
  },
  [`& .${classes.clickableCardSecondaryText}`]: {
    fontSize: 13,
    marginBottom: 5,
  },
  [`& .${classes.clickableCardCTAText}`]: {
    fontSize: 12,
    marginBottom: 0,
    color: theme.palette.primary.main,
    "& svg": {
      fontSize: 12,
    },
  },
  [`& .${classes.clickableCardNumber}`]: {
    fontSize: 30,
    fontWeight: "bold",
    fontFamily: '"Open Sans", sans-serif',
  },
  [`& .${classes.accordionCard}`]: {
    cursor: "pointer",
    boxShadow: "none",
    marginTop: theme.shape.padding,
    border: `1px solid ${theme.palette.border.xdrTrialCard}`,
  },
  [`& .${classes.accordionContainer}`]: {
    padding: "5px 0px",
  },
  [`& .${classes.accordionTitle}`]: {
    fontSize: 15,
    marginBottom: 0,
    fontWeight: "bold",
  },
  [`& .${classes.agreementStepContainer}`]: {
    borderRadius: 10,
    padding: theme.shape.padding,
    marginBottom: theme.shape.padding,
    border: `1px solid ${theme.palette.border.xdrTrialCard}`,
    "& p": {
      fontSize: 13,
      marginBottom: 0,
    },
  },
  [`& .${classes.minimumCommitmentText}`]: {
    fontWeight: "bold",
  },
  [`& .${classes.tableColumnHeaderText}`]: {
    borderRadius: 10,
    padding: "2px 5px",
    fontWeight: "bold",
    textAlign: "center",
    backgroundColor: "lightgreen",
    color: theme.palette.text.primary,
  },
  [`& .${classes.tablePerUserText}`]: {
    fontWeight: "bold",
  },
  [`& .${classes.tablePriceCell}`]: {
    textAlign: "center",
  },
  [`& .${classes.radioTableCellContainer}`]: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
  },
  [`& .${classes.tableRowRoot}`]: {
    "& .MuiTableCell-root": {
      height: 50,
      padding: "5px !important",
    },
  },
  [`& .${classes.stepTitleText}`]: {
    fontWeight: "bold",
    paddingBottom: theme.shape.padding,
  },
  [`& .${classes.stepTableTitleText}`]: {
    fontWeight: "bold",
  },
  [`& .${classes.stepLargeText}`]: {
    fontWeight: "bold",
    fontSize: "15px !important",
    paddingBottom: theme.shape.padding,
  },
  [`& .${classes.currentAgreementList}`]: {
    listStyleType: "none",
    padding: 0,
    fontSize: 14,
  },
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  [`& .${dialogClasses.agreementTitleWrap}`]: {
    display: "flex",
    justifyContent: "space-between",
  },
  [`& .${dialogClasses.agreementIconWrap}`]: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: 105,
  },
  [`& .${dialogClasses.dialogHeaderContainer}`]: {
    display: "flex",
    paddingRight: 30,
    alignItems: "center",
    justifyContent: "space-between",
  },
  [`& .${dialogClasses.dialogTable}`]: {
    // marginLeft: 30,
    // marginRight: 30,
    // marginTop: 30,
    // "& td": {
    //   paddingBottom: 15,
    //   verticalAlign: "top",
    // },
  },
  [`& .${dialogClasses.tableRowLabel}`]: {
    fontWeight: "bold",
    paddingRight: 20,
    whiteSpace: "nowrap",
    fontSize: "14px",
    paddingBottom: 15,
    verticalAlign: "top",
  },
  [`& .${dialogClasses.tableRowText}`]: {
    fontSize: "14px",
    paddingBottom: 15,
    verticalAlign: "top",
  },
  [`& .${dialogClasses.pricingTableRowLabel}`]: {
    fontWeight: "bold",
    paddingRight: 20,
    whiteSpace: "nowrap",
    fontSize: "14px",
    paddingBottom: 5,
    verticalAlign: "top",
  },
  [`& .${dialogClasses.pricingTableRowText}`]: {
    fontSize: "14px",
    paddingBottom: 5,
    verticalAlign: "top",
  },
}));
